import React, { createContext, useState } from 'react';
import { ImageExportTypes } from './types';

type ExportModalContextType = {
  isExportModalOpen: boolean;
  exportType: ImageExportTypes;
  handleOpen: (type: ImageExportTypes) => void;
  handleClose: () => void;
};

export const ExportModalContext = createContext<ExportModalContextType | null>(
  null
);

export const ExportModalProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [exportType, setExportType] = useState<ImageExportTypes>(
    ImageExportTypes.PDF
  );
  const handleOpen = (type: ImageExportTypes) => {
    setIsExportModalOpen(true);
    setExportType(type);
  };

  const handleClose = () => {
    setIsExportModalOpen(false);
    setExportType(ImageExportTypes.PDF);
  };
  return (
    <ExportModalContext.Provider
      value={{ isExportModalOpen, exportType, handleOpen, handleClose }}
    >
      {children}
    </ExportModalContext.Provider>
  );
};
